/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'camera-icon': {
    width: 30,
    height: 30,
    viewBox: '0 0 30 30',
    data: '<g clip-path="url(#clip0)" _fill="#fff"><path pid="0" d="M17.651 13.286a3.75 3.75 0 11-5.303 5.303 3.75 3.75 0 015.303-5.303"/><path pid="1" d="M26.25 5.625h-2.591l-1.876-3.75H8.215L6.341 5.627l-2.587.005A3.757 3.757 0 00.01 9.38L0 24.375a3.755 3.755 0 003.75 3.75h22.5a3.754 3.754 0 003.75-3.75v-15a3.754 3.754 0 00-3.75-3.75zM15 23.438c-4.136 0-7.5-3.364-7.5-7.5s3.364-7.5 7.5-7.5c4.135 0 7.5 3.364 7.5 7.5 0 4.135-3.365 7.5-7.5 7.5z"/></g><defs><clipPath id="clip0"><path pid="2" _fill="#fff" d="M0 0h30v30H0z"/></clipPath></defs>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/camera-icon.js